"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var tus = require("tus-js-client");
var _companionClient = require("@uppy/companion-client");
var _RateLimitedQueue = require("@uppy/utils/lib/RateLimitedQueue");
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
var BasePlugin = require("@uppy/core/lib/BasePlugin");
var emitSocketProgress = require("@uppy/utils/lib/emitSocketProgress");
var getSocketHost = require("@uppy/utils/lib/getSocketHost");
var settle = require("@uppy/utils/lib/settle");
var EventTracker = require("@uppy/utils/lib/EventTracker");
var NetworkError = require("@uppy/utils/lib/NetworkError");
var isNetworkError = require("@uppy/utils/lib/isNetworkError");
var hasProperty = require("@uppy/utils/lib/hasProperty");
var getFingerprint = require("./getFingerprint.js");
var packageJson = {
  "version": "2.4.3"
};
/** @typedef {import('..').TusOptions} TusOptions */

/** @typedef {import('tus-js-client').UploadOptions} RawTusOptions */

/** @typedef {import('@uppy/core').Uppy} Uppy */

/** @typedef {import('@uppy/core').UppyFile} UppyFile */

/** @typedef {import('@uppy/core').FailedUppyFile<{}>} FailedUppyFile */

/**
 * Extracted from https://github.com/tus/tus-js-client/blob/master/lib/upload.js#L13
 * excepted we removed 'fingerprint' key to avoid adding more dependencies
 *
 * @type {RawTusOptions}
 */

var tusDefaultOptions = {
  endpoint: '',
  uploadUrl: null,
  metadata: {},
  uploadSize: null,
  onProgress: null,
  onChunkComplete: null,
  onSuccess: null,
  onError: null,
  overridePatchMethod: false,
  headers: {},
  addRequestId: false,
  chunkSize: Infinity,
  retryDelays: [100, 1000, 3000, 5000],
  parallelUploads: 1,
  removeFingerprintOnSuccess: false,
  uploadLengthDeferred: false,
  uploadDataDuringCreation: false
};
/**
 * Tus resumable file uploader
 */

var _retryDelayIterator = /*#__PURE__*/_classPrivateFieldLooseKey("retryDelayIterator");
var _queueRequestSocketToken = /*#__PURE__*/_classPrivateFieldLooseKey("queueRequestSocketToken");
var _requestSocketToken = /*#__PURE__*/_classPrivateFieldLooseKey("requestSocketToken");
var Tus = /*#__PURE__*/function (_BasePlugin) {
  _inherits(Tus, _BasePlugin);
  var _super = _createSuper(Tus);
  /**
   * @param {Uppy} uppy
   * @param {TusOptions} opts
   */
  function Tus(uppy, _opts) {
    var _this4;
    _classCallCheck(this, Tus);
    var _this$opts$rateLimite, _this$opts$retryDelay;
    _this4 = _super.call(this, uppy, _opts);
    Object.defineProperty(_assertThisInitialized(_this4), _retryDelayIterator, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this4), _queueRequestSocketToken, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this4), _requestSocketToken, {
      writable: true,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(file) {
          var Client, client, opts, res;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                Client = file.remote.providerOptions.provider ? _companionClient.Provider : _companionClient.RequestClient;
                client = new Client(_this4.uppy, file.remote.providerOptions);
                opts = _objectSpread({}, _this4.opts);
                if (file.tus) {
                  // Install file-specific upload overrides.
                  Object.assign(opts, file.tus);
                }
                _context.next = 6;
                return client.post(file.remote.url, _objectSpread(_objectSpread({}, file.remote.body), {}, {
                  endpoint: opts.endpoint,
                  uploadUrl: opts.uploadUrl,
                  protocol: 'tus',
                  size: file.data.size,
                  headers: opts.headers,
                  metadata: file.meta
                }));
              case 6:
                res = _context.sent;
                return _context.abrupt("return", res.token);
              case 8:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function value(_x) {
          return _value.apply(this, arguments);
        }
        return value;
      }()
    });
    _this4.type = 'uploader';
    _this4.id = _this4.opts.id || 'Tus';
    _this4.title = 'Tus'; // set default options

    var defaultOptions = {
      useFastRemoteRetry: true,
      limit: 20,
      retryDelays: tusDefaultOptions.retryDelays,
      withCredentials: false
    }; // merge default options with the ones set by user

    /** @type {import("..").TusOptions} */

    _this4.opts = _objectSpread(_objectSpread({}, defaultOptions), _opts);
    if ('autoRetry' in _opts) {
      throw new Error('The `autoRetry` option was deprecated and has been removed.');
    }
    /**
     * Simultaneous upload limiting is shared across all uploads with this plugin.
     *
     * @type {RateLimitedQueue}
     */

    _this4.requests = (_this$opts$rateLimite = _this4.opts.rateLimitedQueue) != null ? _this$opts$rateLimite : new _RateLimitedQueue.RateLimitedQueue(_this4.opts.limit);
    _classPrivateFieldLooseBase(_assertThisInitialized(_this4), _retryDelayIterator)[_retryDelayIterator] = (_this$opts$retryDelay = _this4.opts.retryDelays) == null ? void 0 : _this$opts$retryDelay.values();
    _this4.uploaders = Object.create(null);
    _this4.uploaderEvents = Object.create(null);
    _this4.uploaderSockets = Object.create(null);
    _this4.handleResetProgress = _this4.handleResetProgress.bind(_assertThisInitialized(_this4));
    _this4.handleUpload = _this4.handleUpload.bind(_assertThisInitialized(_this4));
    _classPrivateFieldLooseBase(_assertThisInitialized(_this4), _queueRequestSocketToken)[_queueRequestSocketToken] = _this4.requests.wrapPromiseFunction(_classPrivateFieldLooseBase(_assertThisInitialized(_this4), _requestSocketToken)[_requestSocketToken]);
    return _this4;
  }
  _createClass(Tus, [{
    key: "handleResetProgress",
    value: function handleResetProgress() {
      var files = _objectSpread({}, this.uppy.getState().files);
      Object.keys(files).forEach(function (fileID) {
        // Only clone the file object if it has a Tus `uploadUrl` attached.
        if (files[fileID].tus && files[fileID].tus.uploadUrl) {
          var tusState = _objectSpread({}, files[fileID].tus);
          delete tusState.uploadUrl;
          files[fileID] = _objectSpread(_objectSpread({}, files[fileID]), {}, {
            tus: tusState
          });
        }
      });
      this.uppy.setState({
        files: files
      });
    }
    /**
     * Clean up all references for a file's upload: the tus.Upload instance,
     * any events related to the file, and the Companion WebSocket connection.
     *
     * @param {string} fileID
     */
  }, {
    key: "resetUploaderReferences",
    value: function resetUploaderReferences(fileID, opts) {
      if (opts === void 0) {
        opts = {};
      }
      if (this.uploaders[fileID]) {
        var uploader = this.uploaders[fileID];
        uploader.abort();
        if (opts.abort) {
          uploader.abort(true);
        }
        this.uploaders[fileID] = null;
      }
      if (this.uploaderEvents[fileID]) {
        this.uploaderEvents[fileID].remove();
        this.uploaderEvents[fileID] = null;
      }
      if (this.uploaderSockets[fileID]) {
        this.uploaderSockets[fileID].close();
        this.uploaderSockets[fileID] = null;
      }
    }
    /**
     * Create a new Tus upload.
     *
     * A lot can happen during an upload, so this is quite hard to follow!
     * - First, the upload is started. If the file was already paused by the time the upload starts, nothing should happen.
     *   If the `limit` option is used, the upload must be queued onto the `this.requests` queue.
     *   When an upload starts, we store the tus.Upload instance, and an EventTracker instance that manages the event listeners
     *   for pausing, cancellation, removal, etc.
     * - While the upload is in progress, it may be paused or cancelled.
     *   Pausing aborts the underlying tus.Upload, and removes the upload from the `this.requests` queue. All other state is
     *   maintained.
     *   Cancelling removes the upload from the `this.requests` queue, and completely aborts the upload-- the `tus.Upload`
     *   instance is aborted and discarded, the EventTracker instance is destroyed (removing all listeners).
     *   Resuming the upload uses the `this.requests` queue as well, to prevent selectively pausing and resuming uploads from
     *   bypassing the limit.
     * - After completing an upload, the tus.Upload and EventTracker instances are cleaned up, and the upload is marked as done
     *   in the `this.requests` queue.
     * - When an upload completed with an error, the same happens as on successful completion, but the `upload()` promise is
     *   rejected.
     *
     * When working on this function, keep in mind:
     *  - When an upload is completed or cancelled for any reason, the tus.Upload and EventTracker instances need to be cleaned
     *    up using this.resetUploaderReferences().
     *  - When an upload is cancelled or paused, for any reason, it needs to be removed from the `this.requests` queue using
     *    `queuedRequest.abort()`.
     *  - When an upload is completed for any reason, including errors, it needs to be marked as such using
     *    `queuedRequest.done()`.
     *  - When an upload is started or resumed, it needs to go through the `this.requests` queue. The `queuedRequest` variable
     *    must be updated so the other uses of it are valid.
     *  - Before replacing the `queuedRequest` variable, the previous `queuedRequest` must be aborted, else it will keep taking
     *    up a spot in the queue.
     *
     * @param {UppyFile} file for use with upload
     * @returns {Promise<void>}
     */
  }, {
    key: "upload",
    value: function upload(file) {
      var _this5 = this;
      var _this = this;
      this.resetUploaderReferences(file.id); // Create a new tus upload

      return new Promise(function (resolve, reject) {
        var queuedRequest;
        var qRequest;
        var upload;
        _this5.uppy.emit('upload-started', file);
        var opts = _objectSpread(_objectSpread({}, _this5.opts), file.tus || {});
        if (typeof opts.headers === 'function') {
          opts.headers = opts.headers(file);
        }
        /** @type {RawTusOptions} */

        var uploadOptions = _objectSpread(_objectSpread({}, tusDefaultOptions), opts); // We override tus fingerprint to uppy’s `file.id`, since the `file.id`
        // now also includes `relativePath` for files added from folders.
        // This means you can add 2 identical files, if one is in folder a,
        // the other in folder b.

        uploadOptions.fingerprint = getFingerprint(file);
        uploadOptions.onBeforeRequest = function (req) {
          var xhr = req.getUnderlyingObject();
          xhr.withCredentials = !!opts.withCredentials;
          var userProvidedPromise;
          if (typeof opts.onBeforeRequest === 'function') {
            userProvidedPromise = opts.onBeforeRequest(req, file);
          }
          if (hasProperty(queuedRequest, 'shouldBeRequeued')) {
            if (!queuedRequest.shouldBeRequeued) return Promise.reject();
            var done;
            var p = new Promise(function (res) {
              // eslint-disable-line promise/param-names
              done = res;
            });
            queuedRequest = _this5.requests.run(function () {
              if (file.isPaused) {
                queuedRequest.abort();
              }
              done();
              return function () {};
            }); // If the request has been requeued because it was rate limited by the
            // remote server, we want to wait for `RateLimitedQueue` to dispatch
            // the re-try request.
            // Therefore we create a promise that the queue will resolve when
            // enough time has elapsed to expect not to be rate-limited again.
            // This means we can hold the Tus retry here with a `Promise.all`,
            // together with the returned value of the user provided
            // `onBeforeRequest` option callback (in case it returns a promise).

            return Promise.all([p, userProvidedPromise]);
          }
          return userProvidedPromise;
        };
        uploadOptions.onError = function (err) {
          _this5.uppy.log(err);
          var xhr = err.originalRequest ? err.originalRequest.getUnderlyingObject() : null;
          if (isNetworkError(xhr)) {
            // eslint-disable-next-line no-param-reassign
            err = new NetworkError(err, xhr);
          }
          _this5.resetUploaderReferences(file.id);
          queuedRequest.abort();
          _this5.uppy.emit('upload-error', file, err);
          reject(err);
        };
        uploadOptions.onProgress = function (bytesUploaded, bytesTotal) {
          _this5.onReceiveUploadUrl(file, upload.url);
          _this5.uppy.emit('upload-progress', file, {
            uploader: _this5,
            bytesUploaded: bytesUploaded,
            bytesTotal: bytesTotal
          });
        };
        uploadOptions.onSuccess = function () {
          var uploadResp = {
            uploadURL: upload.url
          };
          _this5.resetUploaderReferences(file.id);
          queuedRequest.done();
          _this5.uppy.emit('upload-success', file, uploadResp);
          if (upload.url) {
            _this5.uppy.log("Download ".concat(upload.file.name, " from ").concat(upload.url));
          }
          resolve(upload);
        };
        var defaultOnShouldRetry = function defaultOnShouldRetry(err) {
          var _err$originalResponse;
          var status = err == null ? void 0 : (_err$originalResponse = err.originalResponse) == null ? void 0 : _err$originalResponse.getStatus();
          if (status === 429) {
            // HTTP 429 Too Many Requests => to avoid the whole download to fail, pause all requests.
            if (!_this5.requests.isPaused) {
              var _classPrivateFieldLoo;
              var next = (_classPrivateFieldLoo = _classPrivateFieldLooseBase(_this5, _retryDelayIterator)[_retryDelayIterator]) == null ? void 0 : _classPrivateFieldLoo.next();
              if (next == null || next.done) {
                return false;
              }
              _this5.requests.rateLimit(next.value);
            }
          } else if (status > 400 && status < 500 && status !== 409) {
            // HTTP 4xx, the server won't send anything, it's doesn't make sense to retry
            return false;
          } else if (typeof navigator !== 'undefined' && navigator.onLine === false) {
            // The navigator is offline, let's wait for it to come back online.
            if (!_this5.requests.isPaused) {
              _this5.requests.pause();
              window.addEventListener('online', function () {
                _this5.requests.resume();
              }, {
                once: true
              });
            }
          }
          queuedRequest.abort();
          queuedRequest = {
            shouldBeRequeued: true,
            abort: function abort() {
              this.shouldBeRequeued = false;
            },
            done: function done() {
              throw new Error('Cannot mark a queued request as done: this indicates a bug');
            },
            fn: function fn() {
              throw new Error('Cannot run a queued request: this indicates a bug');
            }
          };
          return true;
        };
        if (opts.onShouldRetry != null) {
          uploadOptions.onShouldRetry = function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return opts.onShouldRetry.apply(opts, args.concat([defaultOnShouldRetry]));
          };
        } else {
          uploadOptions.onShouldRetry = defaultOnShouldRetry;
        }
        var copyProp = function copyProp(obj, srcProp, destProp) {
          if (hasProperty(obj, srcProp) && !hasProperty(obj, destProp)) {
            // eslint-disable-next-line no-param-reassign
            obj[destProp] = obj[srcProp];
          }
        };
        /** @type {Record<string, string>} */

        var meta = {};
        var metaFields = Array.isArray(opts.metaFields) ? opts.metaFields // Send along all fields by default.
        : Object.keys(file.meta);
        metaFields.forEach(function (item) {
          meta[item] = file.meta[item];
        }); // tusd uses metadata fields 'filetype' and 'filename'

        copyProp(meta, 'type', 'filetype');
        copyProp(meta, 'name', 'filename');
        uploadOptions.metadata = meta;
        upload = new tus.Upload(file.data, uploadOptions);
        _this5.uploaders[file.id] = upload;
        _this5.uploaderEvents[file.id] = new EventTracker(_this5.uppy); // eslint-disable-next-line prefer-const

        qRequest = function qRequest() {
          if (!file.isPaused) {
            upload.start();
          } // Don't do anything here, the caller will take care of cancelling the upload itself
          // using resetUploaderReferences(). This is because resetUploaderReferences() has to be
          // called when this request is still in the queue, and has not been started yet, too. At
          // that point this cancellation function is not going to be called.
          // Also, we need to remove the request from the queue _without_ destroying everything
          // related to this upload to handle pauses.

          return function () {};
        };
        upload.findPreviousUploads().then(function (previousUploads) {
          var previousUpload = previousUploads[0];
          if (previousUpload) {
            _this5.uppy.log("[Tus] Resuming upload of ".concat(file.id, " started at ").concat(previousUpload.creationTime));
            upload.resumeFromPreviousUpload(previousUpload);
          }
        });
        queuedRequest = _this5.requests.run(qRequest);
        _this5.onFileRemove(file.id, function (targetFileID) {
          queuedRequest.abort();
          _this5.resetUploaderReferences(file.id, {
            abort: !!upload.url
          });
          resolve("upload ".concat(targetFileID, " was removed"));
        });
        _this5.onPause(file.id, function (isPaused) {
          queuedRequest.abort();
          if (isPaused) {
            // Remove this file from the queue so another file can start in its place.
            upload.abort();
          } else {
            // Resuming an upload should be queued, else you could pause and then
            // resume a queued upload to make it skip the queue.
            queuedRequest = _this5.requests.run(qRequest);
          }
        });
        _this5.onPauseAll(file.id, function () {
          queuedRequest.abort();
          upload.abort();
        });
        _this5.onCancelAll(file.id, function (_temp) {
          var _ref = _temp === void 0 ? {} : _temp,
            reason = _ref.reason;
          if (reason === 'user') {
            queuedRequest.abort();
            _this.resetUploaderReferences(file.id, {
              abort: !!upload.url
            });
          }
          resolve("upload ".concat(file.id, " was canceled"));
        });
        _this5.onResumeAll(file.id, function () {
          queuedRequest.abort();
          if (file.error) {
            upload.abort();
          }
          queuedRequest = _this5.requests.run(qRequest);
        });
      }).catch(function (err) {
        _this5.uppy.emit('upload-error', file, err);
        throw err;
      });
    }

    /**
     * @param {UppyFile} file for use with upload
     * @returns {Promise<void>}
     */
  }, {
    key: "uploadRemote",
    value: function () {
      var _uploadRemote = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file) {
        var serverToken;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.resetUploaderReferences(file.id); // Don't double-emit upload-started for Golden Retriever-restored files that were already started

              if (!file.progress.uploadStarted || !file.isRestored) {
                this.uppy.emit('upload-started', file);
              }
              _context2.prev = 2;
              if (!file.serverToken) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", this.connectToServerSocket(file));
            case 5:
              _context2.next = 7;
              return _classPrivateFieldLooseBase(this, _queueRequestSocketToken)[_queueRequestSocketToken](file);
            case 7:
              serverToken = _context2.sent;
              this.uppy.setFileState(file.id, {
                serverToken: serverToken
              });
              return _context2.abrupt("return", this.connectToServerSocket(this.uppy.getFile(file.id)));
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](2);
              this.uppy.emit('upload-error', file, _context2.t0);
              throw _context2.t0;
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 12]]);
      }));
      function uploadRemote(_x2) {
        return _uploadRemote.apply(this, arguments);
      }
      return uploadRemote;
    }()
    /**
     * See the comment on the upload() method.
     *
     * Additionally, when an upload is removed, completed, or cancelled, we need to close the WebSocket connection. This is
     * handled by the resetUploaderReferences() function, so the same guidelines apply as in upload().
     *
     * @param {UppyFile} file
     */
  }, {
    key: "connectToServerSocket",
    value: function connectToServerSocket(file) {
      var _this6 = this;
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        var token = file.serverToken;
        var host = getSocketHost(file.remote.companionUrl);
        var socket = new _companionClient.Socket({
          target: "".concat(host, "/api/").concat(token)
        });
        _this6.uploaderSockets[file.id] = socket;
        _this6.uploaderEvents[file.id] = new EventTracker(_this6.uppy);
        var queuedRequest;
        _this6.onFileRemove(file.id, function () {
          queuedRequest.abort();
          socket.send('cancel', {});
          _this6.resetUploaderReferences(file.id);
          resolve("upload ".concat(file.id, " was removed"));
        });
        _this6.onPause(file.id, function (isPaused) {
          if (isPaused) {
            // Remove this file from the queue so another file can start in its place.
            queuedRequest.abort();
            socket.send('pause', {});
          } else {
            // Resuming an upload should be queued, else you could pause and then
            // resume a queued upload to make it skip the queue.
            queuedRequest.abort();
            queuedRequest = _this6.requests.run(function () {
              socket.send('resume', {});
              return function () {};
            });
          }
        });
        _this6.onPauseAll(file.id, function () {
          queuedRequest.abort();
          socket.send('pause', {});
        });
        _this6.onCancelAll(file.id, function (_temp2) {
          var _ref2 = _temp2 === void 0 ? {} : _temp2,
            reason = _ref2.reason;
          if (reason === 'user') {
            queuedRequest.abort();
            socket.send('cancel', {});
            _this2.resetUploaderReferences(file.id);
          }
          resolve("upload ".concat(file.id, " was canceled"));
        });
        _this6.onResumeAll(file.id, function () {
          queuedRequest.abort();
          if (file.error) {
            socket.send('pause', {});
          }
          queuedRequest = _this6.requests.run(function () {
            socket.send('resume', {});
            return function () {};
          });
        });
        _this6.onRetry(file.id, function () {
          // Only do the retry if the upload is actually in progress;
          // else we could try to send these messages when the upload is still queued.
          // We may need a better check for this since the socket may also be closed
          // for other reasons, like network failures.
          if (socket.isOpen) {
            socket.send('pause', {});
            socket.send('resume', {});
          }
        });
        _this6.onRetryAll(file.id, function () {
          // See the comment in the onRetry() call
          if (socket.isOpen) {
            socket.send('pause', {});
            socket.send('resume', {});
          }
        });
        socket.on('progress', function (progressData) {
          return emitSocketProgress(_this6, progressData, file);
        });
        socket.on('error', function (errData) {
          var message = errData.error.message;
          var error = Object.assign(new Error(message), {
            cause: errData.error
          }); // If the remote retry optimisation should not be used,
          // close the socket—this will tell companion to clear state and delete the file.

          if (!_this6.opts.useFastRemoteRetry) {
            _this6.resetUploaderReferences(file.id); // Remove the serverToken so that a new one will be created for the retry.

            _this6.uppy.setFileState(file.id, {
              serverToken: null
            });
          } else {
            socket.close();
          }
          _this6.uppy.emit('upload-error', file, error);
          queuedRequest.done();
          reject(error);
        });
        socket.on('success', function (data) {
          var uploadResp = {
            uploadURL: data.url
          };
          _this6.uppy.emit('upload-success', file, uploadResp);
          _this6.resetUploaderReferences(file.id);
          queuedRequest.done();
          resolve();
        });
        queuedRequest = _this6.requests.run(function () {
          if (file.isPaused) {
            socket.send('pause', {});
          } // Don't do anything here, the caller will take care of cancelling the upload itself
          // using resetUploaderReferences(). This is because resetUploaderReferences() has to be
          // called when this request is still in the queue, and has not been started yet, too. At
          // that point this cancellation function is not going to be called.
          // Also, we need to remove the request from the queue _without_ destroying everything
          // related to this upload to handle pauses.

          return function () {};
        });
      });
    }
    /**
     * Store the uploadUrl on the file options, so that when Golden Retriever
     * restores state, we will continue uploading to the correct URL.
     *
     * @param {UppyFile} file
     * @param {string} uploadURL
     */
  }, {
    key: "onReceiveUploadUrl",
    value: function onReceiveUploadUrl(file, uploadURL) {
      var currentFile = this.uppy.getFile(file.id);
      if (!currentFile) return; // Only do the update if we didn't have an upload URL yet.

      if (!currentFile.tus || currentFile.tus.uploadUrl !== uploadURL) {
        this.uppy.log('[Tus] Storing upload url');
        this.uppy.setFileState(currentFile.id, {
          tus: _objectSpread(_objectSpread({}, currentFile.tus), {}, {
            uploadUrl: uploadURL
          })
        });
      }
    }
    /**
     * @param {string} fileID
     * @param {function(string): void} cb
     */
  }, {
    key: "onFileRemove",
    value: function onFileRemove(fileID, cb) {
      this.uploaderEvents[fileID].on('file-removed', function (file) {
        if (fileID === file.id) cb(file.id);
      });
    }
    /**
     * @param {string} fileID
     * @param {function(boolean): void} cb
     */
  }, {
    key: "onPause",
    value: function onPause(fileID, cb) {
      this.uploaderEvents[fileID].on('upload-pause', function (targetFileID, isPaused) {
        if (fileID === targetFileID) {
          // const isPaused = this.uppy.pauseResume(fileID)
          cb(isPaused);
        }
      });
    }
    /**
     * @param {string} fileID
     * @param {function(): void} cb
     */
  }, {
    key: "onRetry",
    value: function onRetry(fileID, cb) {
      this.uploaderEvents[fileID].on('upload-retry', function (targetFileID) {
        if (fileID === targetFileID) {
          cb();
        }
      });
    }
    /**
     * @param {string} fileID
     * @param {function(): void} cb
     */
  }, {
    key: "onRetryAll",
    value: function onRetryAll(fileID, cb) {
      var _this7 = this;
      this.uploaderEvents[fileID].on('retry-all', function () {
        if (!_this7.uppy.getFile(fileID)) return;
        cb();
      });
    }
    /**
     * @param {string} fileID
     * @param {function(): void} cb
     */
  }, {
    key: "onPauseAll",
    value: function onPauseAll(fileID, cb) {
      var _this8 = this;
      this.uploaderEvents[fileID].on('pause-all', function () {
        if (!_this8.uppy.getFile(fileID)) return;
        cb();
      });
    }
    /**
     * @param {string} fileID
     * @param {function(): void} eventHandler
     */
  }, {
    key: "onCancelAll",
    value: function onCancelAll(fileID, eventHandler) {
      var _this3 = this;
      this.uploaderEvents[fileID].on('cancel-all', function () {
        if (!_this3.uppy.getFile(fileID)) return;
        eventHandler.apply(void 0, arguments);
      });
    }
    /**
     * @param {string} fileID
     * @param {function(): void} cb
     */
  }, {
    key: "onResumeAll",
    value: function onResumeAll(fileID, cb) {
      var _this9 = this;
      this.uploaderEvents[fileID].on('resume-all', function () {
        if (!_this9.uppy.getFile(fileID)) return;
        cb();
      });
    }
    /**
     * @param {(UppyFile | FailedUppyFile)[]} files
     */
  }, {
    key: "uploadFiles",
    value: function uploadFiles(files) {
      var _this10 = this;
      var promises = files.map(function (file, i) {
        var current = i + 1;
        var total = files.length;
        if ('error' in file && file.error) {
          return Promise.reject(new Error(file.error));
        }
        if (file.isRemote) {
          // We emit upload-started here, so that it's also emitted for files
          // that have to wait due to the `limit` option.
          // Don't double-emit upload-started for Golden Retriever-restored files that were already started
          if (!file.progress.uploadStarted || !file.isRestored) {
            _this10.uppy.emit('upload-started', file);
          }
          return _this10.uploadRemote(file, current, total);
        } // Don't double-emit upload-started for Golden Retriever-restored files that were already started

        if (!file.progress.uploadStarted || !file.isRestored) {
          _this10.uppy.emit('upload-started', file);
        }
        return _this10.upload(file, current, total);
      });
      return settle(promises);
    }
    /**
     * @param {string[]} fileIDs
     */
  }, {
    key: "handleUpload",
    value: function handleUpload(fileIDs) {
      var _this11 = this;
      if (fileIDs.length === 0) {
        this.uppy.log('[Tus] No files to upload');
        return Promise.resolve();
      }
      if (this.opts.limit === 0) {
        this.uppy.log('[Tus] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/tus/#limit-0', 'warning');
      }
      this.uppy.log('[Tus] Uploading...');
      var filesToUpload = fileIDs.map(function (fileID) {
        return _this11.uppy.getFile(fileID);
      });
      return this.uploadFiles(filesToUpload).then(function () {
        return null;
      });
    }
  }, {
    key: "install",
    value: function install() {
      this.uppy.setState({
        capabilities: _objectSpread(_objectSpread({}, this.uppy.getState().capabilities), {}, {
          resumableUploads: true
        })
      });
      this.uppy.addUploader(this.handleUpload);
      this.uppy.on('reset-progress', this.handleResetProgress);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.uppy.setState({
        capabilities: _objectSpread(_objectSpread({}, this.uppy.getState().capabilities), {}, {
          resumableUploads: false
        })
      });
      this.uppy.removeUploader(this.handleUpload);
    }
  }]);
  return Tus;
}(BasePlugin);
Tus.VERSION = packageJson.version;
module.exports = Tus;